import React from 'react';

import { Divider } from 'antd';

import { LayoutPage, LayoutGrid } from 'components/layouts';
import LoadingFullPage from 'components/loading-full-page';

import { useIsProfileComplete } from 'hooks/profile';
import stages from 'containers/employer/stages';

import UncompleteProfile from './uncomplete-profile';
import TokensWidget from './tokens-widget';
import WorkersWidget from './workers-widget';
import BookingsWidget from './bookings-widget';

import './style.css';
import RatingAverage from 'components/rating-average';
import { useUserWithRole } from 'hooks/custom-auth';
import Client from 'containers/app/client';

const Dashboard = () => {
  const [profile, loading] = useIsProfileComplete(stages);
  const [user, loadingUser, errorUser] = useUserWithRole(Client.auth);

  if (loading || loadingUser)
    return (
      <LayoutPage className="dashboard-page">
        <LayoutPage.Container className="wrapper">
          <LoadingFullPage />;
        </LayoutPage.Container>
      </LayoutPage>
    );

  if (errorUser) throw errorUser;

  const progressWidth = 80;
  const profilePercentage = Math.round((profile / stages.length) * 100);
  const isRegistrationFinish = profilePercentage === 100;

  return (
    <LayoutPage className="dashboard-page">
      <LayoutPage.Container className="wrapper">
        <h1>Dashboard</h1>
        {isRegistrationFinish ? (
          <>
            <LayoutGrid>
              <TokensWidget />
              <WorkersWidget />
              <RatingAverage role="isEmployer" userId={user.claims.user_id} />
            </LayoutGrid>
            <Divider />
            <BookingsWidget />
          </>
        ) : null}
        <UncompleteProfile
          progressWidth={progressWidth}
          profilePercentage={profilePercentage}
        />
      </LayoutPage.Container>
    </LayoutPage>
  );
};

export default Dashboard;
